import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { Logo } from "../../components/Layouts";

export default function ForgotPassword() {
  return (
    <div className="auth-page">
      <div className="auth-aside">
        <Logo />
        <div><div className="eyebrow">ACCOUNT RECOVERY</div><h1>Restore your<br /><em>account access.</em></h1><p>Email and SMS recovery messages are currently disabled.</p></div>
        <div className="auth-foot">© {new Date().getFullYear()} World Help Agency</div>
      </div>
      <div className="auth-form-wrap">
        <div className="auth-form">
          <ShieldCheck size={30} />
          <h2>Account recovery</h2>
          <div className="note" data-testid="password-recovery-disabled">Contact an administrator if you cannot access your account.</div>
          <div className="form-switch"><Link data-testid="back-to-login" to="/login">Back to sign in</Link></div>
        </div>
      </div>
    </div>
  );
}